import { Grid, Button, Box } from "@material-ui/core";
import { useNotify, useRedirect } from "ra-core";
import { useParams } from "react-router-dom";
import { useState } from "react";
import TextInputRA from "../components/TextInputRA";
import LeftGridEdit from "../components/LeftGridEdit";
import RightGridEdit from "../components/RightGridEdit";
import LayoutContainer from "../components/LayoutContainer";
import StatusInput from "../components/StatusInput";
import RoleandBranchInput from "../components/RoleandBranchInput";
import BranchesSelect from "../components/BranchesSelect";
import UserValidation from "../../../ValidationRules/UserValidation";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import settings from "../../../utils/settings";
import ChangePasswordDialog from "../components/ChangePasswordDialog";
import { Loading } from "react-admin";
import useCheckPermissionHook from "../../../hooks/useCheckPermissionHook";
const transform = (data) => {
  if (!data.branchSelected)
    return {
      ...data,
      roles: [
        {
          scope: {
            branch_id: data.branches.map((branch) => branch.id),
          },
          role_id: data.role_id,
        },
      ],
    };
  return {
    ...data,
    roles: [
      {
        scope: {
          branch_id: data.branchSelected,
        },
        role_id: data.role_id,
      },
    ],
  };
};

const UserEdit = (props) => {
  const { id } = useParams();
  const [showChangePassword, setShowChangePassword] = useState();
  const { id: currentId } = settings();
  const notify = useNotify();
  const redirect = useRedirect();

  const { loading, allow } = useCheckPermissionHook({
    code: "Page.Merchant.Management.User",
    write: true,
  });
  if (loading) return <Loading />;

  const onSuccess = () => {
    notify("Edit successfully"); // default message is 'ra.notification.updated'
    redirect("list", props.basePath);
  };
  const onFailure = (error) => {
    console.error(error);
    if (error.code === 123) {
      notify(
        "Could not save changes: concurrent edition in progress",
        "warning"
      );
    } else {
      notify("ra.notification.http_error", "warning");
    }
    redirect("list", props.basePath);
  };

  return (
    <LayoutContainer>
      <Grid container style={{ height: "100%" }}>
        <LeftGridEdit
          onSuccess={onSuccess}
          onFailure={onFailure}
          transform={transform}
          {...props}
          validate={UserValidation}
          noDelete={id === currentId}
          disabled={!allow && id !== currentId}
        >
          <SfBreadcrumbs path="Management/Users/Edit" />
          <Box style={{ margin: 50 }}>
            <TextInputRA required label="Username" source="username" disabled />
            <TextInputRA
              required
              source="identification.employee_no"
              label="Employee number"
              format={(input) => String(input ?? "")}
              parse={(input) => String(input ?? "")}
              disabled
            />
            <TextInputRA required source="firstname" label="Firstname" />
            <TextInputRA required source="lastname" label="Lastname" />
            <TextInputRA type="date" label="Birthdate" source="birthdate" />
            <TextInputRA required label="Phone" source="phone" type="phone" />
            <TextInputRA required label="Email" source="email" />
            <RoleandBranchInput required />
            <BranchesSelect required />
            <TextInputRA
              required
              label="Last access"
              source="last_access_time"
              disabled
            />
            <TextInputRA required label="Create date" source="time" disabled />
            <StatusInput />
          </Box>
        </LeftGridEdit>
        <RightGridEdit
          {...props}
          resource="merchant-users"
          customComponent={
            id === currentId ? (
              <Button
                style={{ marginTop: 50 }}
                variant="contained"
                color="secondary"
                onClick={() => setShowChangePassword(true)}
              >
                Change Password
              </Button>
            ) : null
          }
        />
      </Grid>
      <ChangePasswordDialog
        id={id}
        onClose={() => setShowChangePassword(false)}
        open={showChangePassword}
        notify={notify}
      />
    </LayoutContainer>
  );
};

export default UserEdit;
